import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http'
import * as moment from 'moment';
import { faHome, faEdit, faMoneyCheck, faFileContract, faMoneyCheckAlt, faRupeeSign, faTimes, faFileDownload, faCheckCircle, faSadTear, 
  faTools, faChevronDown, faClock, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { gutil } from '../gutil';
import {  Router } from "@angular/router";
import { PaymentService } from '../services/payment.service';


@Component({
  selector: 'app-tenantdb',
  templateUrl: './tenantdb.component.html',
  styleUrls: ['./tenantdb.component.scss']
})
export class TenantDbComponent implements OnInit {


  public faHome = faHome;
  public faEdit = faEdit;
  public faMoneyCheck = faMoneyCheck;
  public faFileContract = faFileContract;
  public faMoneyCheckAlt = faMoneyCheckAlt;
  public faRupeeSign = faRupeeSign;
  public faTimes = faTimes;
  public faFileDownload = faFileDownload;
  public faCheckCircle = faCheckCircle;
  public faSadTear = faSadTear;
  public faTools = faTools;
  public faChevronDown = faChevronDown;
  public faClock = faClock;
  public faTimesCircle = faTimesCircle;

  public user: any;
  public tenantDetails: Array<any>;
  public schedules:any;
  public rentReceipts = [];
  public depoRecps:any;
  public depositDate: any;
  public userexit = {pid:0,puid:0, exitdate:"", reason:""};
  public minExitDate:any;
  
  public serviceRequest = {type:0,subtype:0,user_id:0,property_id:0,room_id:0,status:1,detail:"" };
  public serviceRequestTypes: any;
  public tenantName: string;
  public getDocuments: any;

  public sRequestTotal:number;
  public sRequestData:Array<any>;

  public openServiceRequest: Array<any>;
  public srPending: any= 0;
  public srClosed: any= 0;

  public totalKeyServices:any=0;
  public totalKeyServicesPending: any = 0;
  public totalKeyServicesClosed:any;

  public totalPlumbingServices: any=0;
  public totalPlumbingservicesPending:any=0;
  public totalPlumbingServicesClosed:number=0;


  public totalFurnishingServices: any=0;
  public totalFurnishingServicesPending:any=0;
  public totalFurnishingServicesClosed:any=0;

  public totalElectricalServices: any=0;
  public totalElectricalServicesClosed:any=0;
  public totalElectricalServicesPend:any=0;

  public totalCleaningServices: any=0;
  public totalCleaningServicesClosed: any= 0;
  public totalCleaningServicesPending: any=0;

  public totalCarpentryServices: any=0;
  public srClosedCarpentry:any=0;
  public srPendingCarpentry:any=0;

  public totalOtherServices: any=0;
  public totalOtherServicesClosed:any=0;
  public totalOtherServicesPending:any=0;

  public tenantServiceList : Array<any>;
  public activeServiceList: Array<any>;


  public tenantRentalAgreement: any;
  public remainingAgreementDays: number;

  public alertOpen: boolean;
  public alertClose: boolean;
  
  public outstandingAmount:number;
  public paymentType: string;
  public paymentTypeId: number;
  public outstandingPaymentData: Array<any>;
  public totalOutstandingData = [];

  public payAmtRazorPay: any;
  public payAmtPaytm : any;
  public qrcodeval : any;

  public gatewaycheck:string;
  public paymentButton: boolean = true;

  public individualServices = [];
  public serviceRequestTypeId: number;

  public submitMessage: string;

  public serviceRequestBgColors = ['rgb(246, 104, 104)',
            'rgb(54, 162, 235)',
            'rgb(75, 192, 192)',
            'rgb(255, 205, 86)',
            'rgb(153, 102, 255)',
            'rgb(193, 154, 107)',
            'rgb(231,233,237)'
          ];

  constructor(private http: HttpClient, private router: Router, private paymentService: PaymentService) { 

    this.serviceRequestTypes = gutil.srTypesSel;
    
  }

  
  ngOnInit(): void {
    window.scrollTo(0,0);
    
    this.user = gutil.user;        
    this.fetchData();
    this.minExitDate = moment().add(31, 'days').format('YYYY-MM-DD');
    this.userexit.exitdate = 'Please Select Date';

    var tenantFullName = this.user.name.split(" "); 
    this.tenantName = tenantFullName[0];
          
    this.getServiceList();                  
    
  }  
  
  public async fetchData() {
    this.getTenantData();     
    this.getDocumentList();
    this.fetchActiveServiceRequests();  
    this.payOutstandingAmt('rent', this.user.id);  
    

  }

  // public payOutstandingAmt(paymentType: any, paymentTypeId: number) {    
  //   // if(paymentTypeId !== undefined && paymentTypeId !== null) {      
  //     this.payRent(paymentType, paymentTypeId);
  //   // }
  // }
  
  public payOutstandingAmt(type: string, id: number) {

    this.paymentType = type;
    this.paymentTypeId = id;
    // this.rentDataLoader = 0;
    this.http.get(gutil.devapiUrl + '/api/v1/payment/schedules/' + this.user.id + '?api_token=' + this.user.api_token)
        .subscribe((data:any)=> {
          this.outstandingPaymentData = data.obj;
          // this.rentDataLoader = 0;
          let rda = 0;
          let currDate = new Date();
          let currMonth = currDate.getMonth() + 1;
          let currYear = currDate.getFullYear();

          for(let rent in this.outstandingPaymentData) {
            if(this.outstandingPaymentData[rent].objecttype == "rent" && this.outstandingPaymentData[rent].status == 1) {
              let invDate = new Date(this.outstandingPaymentData[rent].inv_startdate);
              let invMonth = invDate.getMonth() + 1;
              let invYear = invDate.getFullYear();
              if( invYear < currYear){
                this.totalOutstandingData[rda] = Number(this.outstandingPaymentData[rent].amount);
                rda++;
              }
              else if(invYear == currYear){
                if(invMonth <= currMonth){
                  this.totalOutstandingData[rda] = Number(this.outstandingPaymentData[rent].amount);
                  rda++;
                }
              }
              else{
                continue;
              }
            }
          }

          let rentAmt = 0;
          
          for(let num of this.totalOutstandingData) {
            rentAmt = rentAmt + num;
            this.outstandingAmount = rentAmt;
          }          

          var convFeeAmt = this.outstandingAmount*(1.75/100) + this.outstandingAmount*(1.75/100)*0.18;
          this.payAmtRazorPay = this.outstandingAmount + Math.round(convFeeAmt);
          this.payAmtPaytm = this.outstandingAmount;
          this.qrcodeval = "upi://pay?pa=yourownroom@dbs&pn=YourOwnRoom&tr="+id+"&tn="+this.user.name+"&am="+this.outstandingAmount+"&cu=INR&mode=01&orgid=000000";
          // this.rentDataLoader = 1;
          
        })
  }
  
  public initPayment() {  
    this.paymentService.initiatePayment(this.paymentTypeId , this.outstandingAmount, this.paymentType , "Proceed for payment of Rs. " + this.outstandingAmount , "", undefined , this.gatewaycheck);
    
  }

  public getTenantData() {
    this.http.get(gutil.devapiUrl + '/api/v1/property/tenant/' + this.user.id + '/dashboard?api_token=' + this.user.api_token)
      .subscribe((data: any) => {              

        this.tenantDetails = data.obj;                
        this.tenantDetails[0].occupto = moment(this.tenantDetails[0].occupto).format("DD MMM, YYYY");
        this.tenantDetails[0].occupfrom = moment(this.tenantDetails[0].occupfrom).format("DD MMM, YYYY")        

        this.remainingAgreementDays = moment(this.tenantDetails[0].occupto).diff(moment(), "days");        
      })
  }

  // Payment Schedules
  public fetchPaymentSchedules(){
    
    this.http.get(gutil.devapiUrl + '/api/v1/payment/schedules/' + this.user.id + '?api_token=' + this.user.api_token )
        .subscribe((data:any) => {
          this.schedules = data.obj;
          if(data.payschs != -1) {            
            let ri = 0;            
            let d : Date; 
            
            for(let psi in this.schedules) {              
              d = new Date(this.schedules[psi].schldate);
              this.schedules[psi].dispMonth = gutil.monthNames[d.getMonth()] + ", " + d.getFullYear();
                if(this.schedules[psi].objecttype == "rent" && this.schedules[psi].status == 2) {
                    this.rentReceipts[ri] = this.schedules[psi];
                    ri++;
                }                  
            }            
          }
          
        },
        err => console.error(err)
        );
  }

  //Exit Process
  public changeExitReason(value: string) {
    this.userexit.reason = value;
  }
  public changeExitDate(value: any) {
    this.userexit.exitdate = value;
  }

  public initiateExitProcess(puid:number,pid:number) {
    this.userexit.puid=puid;
    this.userexit.pid = pid;
    
    this.initExit();

  }

  public initExit() {
        
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    let options =  {headers: headers }; 
    let params = new URLSearchParams();
    let d = new Date(this.userexit.exitdate);
    
    params.append('exit_date', d.getFullYear() + "-" + (d.getMonth()<9 ? "0"  : ""  ) + (d.getMonth()+1) + "-" + (d.getDate()<10 ? "0"  : ""  ) + d.getDate());
    params.append('exit_reason', this.userexit.reason);
    params.append('uid', "" + this.user.id);
    params.append('puid', "" + this.userexit.puid);
    params.append('pid', "" + this.userexit.pid);
    params.append('exit_status', '1');

    let paramsString = params.toString();    
    
    this.http.post(gutil.devapiUrl + '/api/v1/user/updateexitrequest?api_token=' + this.user.api_token, paramsString, options)
        .subscribe((data: any) => {          
          
          this.submitMessage = data.messages[0].message;
          if(data.obj == 1) {
            this.submitMessage = "Exit Request raised successfully!!";
          }
          this.openNotification();

          this.getTenantData();

        });        
  }

  //Service Request

  public async getServiceList() {
    this.fetchServiceRequests()
  }
  public fetchActiveServiceRequests() {
    this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id + '?api_token=' + this.user.api_token)
      .subscribe((services: any) => {
        
        let activeServicesReqs = services.data;
        let asr = 0;
        let activeList = [];
        
        for(let i = 0; i < activeServicesReqs.length; i++) {
          if(activeServicesReqs[i].status == 1 || activeServicesReqs[i].status == 2) {
            activeList[asr] = activeServicesReqs[i];
            activeList[asr].created_at = moment(activeList[asr].created_at).format("DD MMM, YYYY");
            asr++;
          }
        }
        this.activeServiceList = activeList.slice(0, 2);
        this.activeServiceList        
      })
  }

  public resetServiceData() {
    this.sRequestTotal = this.srClosed = this.totalKeyServices = this.totalPlumbingServices = this.totalCleaningServices =
    this.totalElectricalServices = this.totalFurnishingServices = this.totalCarpentryServices = this.totalOtherServices = 0;  
  }
  public fetchServiceRequests() {  
    this.resetServiceData();

    this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id + '?api_token=' + this.user.api_token)
      .subscribe((data:any) => {

        this.sRequestTotal = data.total;
        this.sRequestData = data.data; 
  
                
        this.tenantServiceList = this.sRequestData.map(item => item.type).filter((value, index , self)=> self.indexOf(value) === index);
        this.tenantServiceList.sort();
        

        for(let i = 0 ; i < this.sRequestData.length ; i++){
          //Loop for Pending and Closed Requests
          if(this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1 ){
              this.srPending += 1;
          }
          else if(this.sRequestData[i].status == 5){
              this.srClosed += 1;
          }          

          //Keys Services
          if(this.sRequestData[i].type == 1) {
            this.totalKeyServices +=1;
            if(this.sRequestData[i].type == 1 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalKeyServicesPending +=1;
            }
            else if(this.sRequestData[i].type == 1 && this.sRequestData[i].status == 5) {
              this.totalKeyServicesClosed +=1;
            }
          }

          //Plumbing Services
          if(this.sRequestData[i].type == 12) {
            this.totalPlumbingServices +=1;
            if(this.sRequestData[i].type == 12 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalPlumbingservicesPending +=1;
            }
            else if(this.sRequestData[i].type == 12 && this.sRequestData[i].status == 5) {
              this.totalPlumbingServicesClosed +=1;
            }
          }

          //Furnishing Services
          if(this.sRequestData[i].type == 17) {
            this.totalFurnishingServices +=1;
            if(this.sRequestData[i].type == 17 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalFurnishingServicesPending +=1;
            }
            else if(this.sRequestData[i].type == 17 && this.sRequestData[i].status == 5) {
              this.totalFurnishingServicesClosed +=1;
            }
          }

          //Cleaning Services
          if(this.sRequestData[i].type == 47) {
            this.totalCleaningServices +=1;
            if(this.sRequestData[i].type == 47 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalCleaningServicesPending +=1;
            }
            else if(this.sRequestData[i].type == 47 && this.sRequestData[i].status == 5) {
              this.totalCleaningServicesClosed +=1;
            }
          }

          //Electrical Services
          if(this.sRequestData[i].type == 49) {
            this.totalElectricalServices +=1;
            if(this.sRequestData[i].type == 49 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalElectricalServicesPend +=1;
            }
            else if(this.sRequestData[i].type == 49 && this.sRequestData[i].status == 5) {
              this.totalElectricalServicesClosed +=1;
            }
          }

          //Carpentry Services
          if(this.sRequestData[i].type == 51) {
            this.totalCarpentryServices +=1;
            if(this.sRequestData[i].type == 51 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.srPendingCarpentry +=1;
            }
            else if(this.sRequestData[i].type == 51 && this.sRequestData[i].status == 5) {
              this.srClosedCarpentry +=1;
            }
          }

          //Others Services
          if(this.sRequestData[i].type == 60) {
            this.totalOtherServices +=1;
            if(this.sRequestData[i].type == 60 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
              this.totalOtherServicesPending +=1;
            }
            else if(this.sRequestData[i].type == 60 && this.sRequestData[i].status == 5) {
              this.totalOtherServicesClosed +=1;
            }
          } 
        } 
    });    
    
  }

  public raiseNewServiceRequest(property_id: number, room_id: number) {
    
    this.serviceRequest.property_id = property_id;
    this.serviceRequest.room_id = room_id;
    this.serviceRequest.user_id = this.tenantDetails[0].user_id;
    
    this.submitServiceRequest();
  }

  public onServiceTypeChange(value:any) {
    this.serviceRequest.type = value;
  }
  public onServiceDescriptionChange(value:any){
    this.serviceRequest.detail = value.target.value;
  }  

  public submitServiceRequest() {
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    let options =  {headers: headers };
    let params = new URLSearchParams();

    for(let x in this.serviceRequest){   
        params.append(x, this.serviceRequest[x]);
    }
    let paramsString = params.toString();     
    
    this.http.post(gutil.devapiUrl + '/api/v1/services/edit?api_token=' + this.user.api_token , paramsString, options)
        .subscribe((data:any) => {     
          
          this.submitMessage = data.messages[0].message;  
          this.openNotification();
          
        });  
    
    
  }
  
  public serviceRequestDetail(serviceTypeId : number) {

    this.serviceRequestTypeId =  serviceTypeId;
    this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id  + '?api_token=' + this.user.api_token)
        .subscribe((services:any)  =>{
                    
          let serviceData = services.data;
          let sRequestIndex = 0;
          this.individualServices = [];
          
          for(let i = 0; i < services.total; i++) {            
            if(serviceTypeId == serviceData[i].type) {
              this.individualServices[sRequestIndex] = serviceData[i];     
              this.individualServices[sRequestIndex].created_at = moment(this.individualServices[sRequestIndex].created_at).format("DD MMM, YYYY");
              sRequestIndex++;
            }
          } 

        })    
  }

  //Documents
  public getDocumentList() {
    this.http.get(gutil.devapiUrl + '/api/v1/documents/info/' + this.user.id + '?api_token=' + this.user.api_token)
      .subscribe((docs: any) => {        
        this.getDocuments = docs.data;
        
        for(let doc = 0; doc < docs.length; doc++) {
          this.getDocuments[doc].created_at = moment(this.getDocuments[doc].created_at).format("DD MMM, YYYY");

          if(this.getDocuments[doc].type == 'rent') {
            this.tenantRentalAgreement = this.getDocuments[doc].url;
          }
        }          
      })
  }

  public initiateAgreementRenewal() {
        
    this.alertOpen = true;
    this.submitMessage = "Thank You! We'll initiate your renewal process.";

    this.openNotification();

  }
  public viewRentalAgreement() {    
    this.getDocumentList();    
    window.open(this.tenantRentalAgreement, '_blank');

  }
  public openDocs(url: string){
    window.open(url , '_blank');
  }

  public openEditProfile() {
    this.router.navigate(['/editprofile']);
  }

  public openNotification() {
    this.alertOpen = true;
    setTimeout(() => {
      this.alertOpen = false;
    }, 3000)

    
  }
}
